import {
  ACCESS_TYPE_BLOCK_ID,
  REASON_BLOCK_ID,
  REQUEST_TIME_BLOCK_ID,
  RESOURCE_SELECTOR_BLOCK_ID,
} from "@p0security/shared/integrations/notifiers/constants";
import type {
  WebBlock,
  WebModalState,
  WebStringBlock,
} from "@p0security/shared/integrations/notifiers/web-requests/types";
import type { BundleItem } from "@p0security/shared/types/bundle";

export {
  BlocksRenderer,
  type FetchOptionsArgs,
} from "components/Jit/Modal/BlockRenderers";

export const HIDDEN_BLOCK_IDS: string[] = [
  REQUEST_TIME_BLOCK_ID,
  REASON_BLOCK_ID,
];

export const filterBundleResource = (blocks: WebBlock[]): WebBlock[] =>
  blocks.map((block) =>
    block.id === RESOURCE_SELECTOR_BLOCK_ID &&
    block.type === "static-select" &&
    block.options
      ? {
          ...block,
          options: block.options.filter((opt) => opt.value !== "bundle"),
        }
      : block
  );

export const isValueBlock = (block: WebBlock): block is WebStringBlock =>
  block.type === "static-select" ||
  block.type === "dynamic-select" ||
  block.type === "input";

export const buildBundleItem = (
  blocks: WebBlock[],
  values: WebModalState
): BundleItem | undefined => {
  const type = values[RESOURCE_SELECTOR_BLOCK_ID];
  if (typeof type !== "string" || !type) return undefined;

  const accessType = values[ACCESS_TYPE_BLOCK_ID];
  const args: Record<string, unknown> = {};
  for (const block of blocks) {
    if (
      [
        RESOURCE_SELECTOR_BLOCK_ID,
        ACCESS_TYPE_BLOCK_ID,
        ...HIDDEN_BLOCK_IDS,
      ].includes(block.id) ||
      (!isValueBlock(block) && block.type !== "toggle")
    )
      continue;
    const value = values[block.id];
    if (
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    )
      continue;
    const prefix = `${type}_${accessType}_`;
    const argKey = block.id.startsWith(prefix)
      ? block.id.slice(prefix.length)
      : block.id;
    args[argKey] = value;
  }

  return {
    type,
    access: typeof accessType === "string" ? accessType : "",
    args,
  };
};
